module.exports = __webpack_public_path__ + "img/8-2.68304600.jpg";